import { ToggleButton } from "@mui/material"

// ToggleButtonGroup reaches its buttons through context, so they need not be direct children
export function SkillMapViewModeOption({ item }) {
    return (
        <ToggleButton value={item.value} data-cy={`skill-map-view-${item.value}`}>
            {item.label}
        </ToggleButton>
    )
}
